module.exports = __webpack_public_path__ + "img/theme-d.cd0b5585.png";